<template>
  <div>
    <div class="breadcrumb-list">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active">Profile</li>
      </ol>
      <div class="emp-button btn-align text-right" v-if="user && (user.type=='MANAGER' || (user.type=='EMPLOYEE' && user.managerAccess=='yes'))">
        <button type="button" data-toggle="modal" data-target="#creat-employee" class="btn btn-outline-primary">Create New Employee</button>
      </div>
    </div>
    <div class="main-box two-column">
          <employee-sidebar v-bind:employeeData="employeeId"></employee-sidebar>
      <div class="emplyee-info-wrp p-0 bg-transparent">
        <div
          class="main-box salary-slip-block"
          v-for="info in employee_info"
          :key="info.id"
        >
          <div class="salary-slip-head">
            <h3>employee</h3>
            <span>{{ info.name }}</span>
          </div>
          <div class="text-wrapper">
            <div class="emp-salary-info">
              <ul class="emp-info-ul">
                <li>
                  <span class="title">Phone</span
                  ><span class="title-info">{{ info.phone }}</span>
                </li>
                <li>
                  <span class="title">Employee #</span
                  ><span class="title-info">{{ info.reg_no }}</span>
                </li>
                <li>
                  <span class="title">Address</span
                  ><span class="title-info">{{ info.address }}</span>
                </li>
              </ul>
              <ul class="sending-checks">
                <li>
                  <span class="check-label"> Send an Email </span>
                  <label class="switch">
                    <input type="checkbox" v-model="mailStatus"  @change="email(info.id)" class="default" />
                    <!-- <span class="slider round"></span> -->
                    <span class="slider round"></span>
                  </label>
                </li>
                <li>
                  <span class="check-label"> Send SMS </span>
                  <label class="switch">
                    <input type="checkbox" class="default" />
                    <span class="slider round"></span>
                  </label>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="row" v-if="employee.length !== 0">
          <div class="col-lg-12 col-xl-12 mb-20 mb-lg-0">
            <div class="table-scroll salary-table">
              <table class="table" id="tblData">
                <thead class="table-head">
                  <tr>
                    <th scope="col">PEROID</th>
                    <th scope="col">GROSS SALARY</th>
                    <th scope="col">TRANSFERRED</th>
                    <th scope="col">ACTION</th>
                  </tr>
                </thead>
                <tbody v-for="salary in employee" :key="salary.id">
                  <tr>
                    <td>
                      {{
                        salary.salaryCalculationPeriod.from_date | formatDate2
                      }}
                      -
                      {{ salary.salaryCalculationPeriod.to_date | formatDate2 }}
                    </td>
                    <td>{{ amountFormatter(salary.gross) }}</td>
                    <td v-if="salary.transfered === true">Yes</td>
                    <td v-if="salary.transfered === false">No</td>
                    <td class="action-btn-cus">

                        <span title="Download salary slip" v-on:click="salaryCalculateReport(salary.id,salary.gross,'download')" :ref="salary.id+'-icon1'"
                              class="download-icon mr-10">
                        <i class="ico ico-download"></i>
                      </span>
                       <span title="Send email salary slip" v-on:click="salaryCalculateReport(salary.id,salary.gross,'email')" :ref="salary.id+'-icon1'"
                             class="download-icon">
                        <i class="ico ico-email"></i>
                      </span>
                       <clip-loader :loading="loadingSpin" :size="size" :color="spinnerColor" :ref="salary.id+'-slip1'"></clip-loader>

                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div v-else>Data not found</div>
      </div>
      <createEmployeeModal></createEmployeeModal>
    </div>
  </div>
</template>

<script>
// import {saveAs} from 'file-saver';
import createEmployeeModal from "../Employees/createEmployeeModal";
import employeeSidebar from "../Employees/employeeSidebar";
import ClipLoader from 'vue-spinner/src/ClipLoader.vue';

export default {
  name: "employeeSalary",
  components: {
        employeeSidebar,ClipLoader,
        createEmployeeModal,
	},
  data() {
    return {
      size          : '25px',
      spinnerColor  : '#00779C',
      loadingSpin   : false,
      employeeId    : this.$store.getters.getEmployeeProfileId,
      company_id    : this.$store.getters.getSelectedCompany.id,
      employee      : [],
      employee_info : [],
      grossSalary   : [],

      form: {
        employee_id : [],
        period_id   : "",
        grossSalary : "",
        employee    : ''
      },
      path          : "",
      mailStatus    : false,
      user          : this.$store.getters.getUser,
    };
  },
  mounted() {
    this.$root.$emit("activeCompoClick");
    this.employee_id = this.employeeId.id || "";
    this.salary();
  },

  methods: {
    salary() {
      var params = {
        employee_id: this.employeeId.id,
        company_id: this.company_id
      };
      this.$axios
        .get(this.$SalarySlip, {
          params: params,
          headers: this.getAuthHeader(),
        })
        .then((response) => {
          this.grossSalary    = response.data.result.gross;
          this.employee       = response.data.result.user_info;
          this.employee_info  = response.data.result.info;
          this.mailStatus     = this.employee_info[0].send_email_status === 'Yes'?true:false;
          this.is_calculate == 1;
          this.form.employee_id = this.employee_id;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    ExportXLSX() {
      //Export in Excel
      if (this.val != 0) {
        this.isHidden = true;
        var tab_text = "<table border='2px'><tr bgcolor='#87AFC6'>";
        var textRange;
        var j = 0;
        var tab = document.getElementById("tblData"); // id of table

        for (j = 0; j < tab.rows.length; j++) {
          var row = tab.rows[j];
          var numberOfCells = row.cells.length;
          row.deleteCell(numberOfCells - 1);
          tab_text = tab_text + tab.rows[j].innerHTML + "</tr>";
        }

        // tab_text=tab_text+"</table>";
        // tab_text= tab_text.replace(/<A[^>]*>|<\/A>/g, "");//remove if u want links in your table
        // tab_text= tab_text.replace(/<img[^>]*>/gi,""); // remove if u want images in your table
        // tab_text= tab_text.replace(/<input[^>]*>|<\/input>/gi, ""); // reomves input params

        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");

        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
          // If Internet Explorer
          txtArea1.document.open("txt/html", "replace");
          txtArea1.document.write(tab_text);
          txtArea1.document.close();
          txtArea1.focus();
          sa = txtArea1.document.execCommand("SaveAs", true, "Thanks.xls");
        }
        // 	var sa = window.open('data:application/vnd.ms-excel,' + encodeURIComponent(tab_text));
        // return (sa);
        else {
          let a = $("<a />", {
            href:
              "data:application/vnd.ms-excel," + encodeURIComponent(tab_text),
            download: "SalaryCalculations.xls",
          })
            .appendTo("body")
            .get(0)
            .click();
        }
      } else {
        alert("first calculate");
      }
    },
    email(id) {
      this.$axios
        .post(this.$ChangeSalaryEmailStatus, {
          id:id,
          mailStatus:this.mailStatus
        }, {
          headers: this.getAuthHeader(),
        })
        .then((response) => {
        })
        .catch((error) => {
          console.log(error);
        });
    },
    salaryCalculateReport(salaryCalculateId, grossSal,type) {
     if(type ==='email'){
       var url=this.$SalaryEmail;
     }else{
       var url=this.$DownloadEmployeeSalaryReport;
     }
      let refi    = salaryCalculateId+'-slip1';
      let anchor  = this.$refs[salaryCalculateId+'-icon1'][0];
      // $(anchor).addClass('d-none');
      this.$refs[refi][0].loading  = true;
      this.form.salary_calculate_id   = salaryCalculateId;
      this.form.grossSalary = grossSal;
      this.form.employee    = this.employee;
      this.form.type    = type;
      this.$axios({
        method        : "POST",
        data          : this.form,
        url           : url,
        responseType  : 'blob',
        headers       : this.getAuthHeader()
      }).then((response) => {
        // this.path = response.data.result;
          if(type ==='download'){
            this.downloadFile(response.data);
          }
        this.$refs[refi][0].loading  = false;
        let anchor = this.$refs[salaryCalculateId+'-icon1'][0];
        // $(anchor).addClass('d-block');
        $root.$toast.success('Action performed successfully');
      })
        .catch((error) => {
          console.log(error);
          this.is_data_ready = true;
        });
    },
    sendEmail(salaryCalculateId, grossSal) {
      let refi    = salaryCalculateId+'-slip1';
      let anchor  = this.$refs[salaryCalculateId+'-icon1'][0];
      $(anchor).addClass('d-none');
      this.$refs[refi][0].loading  = true;
      // return;
      this.form.salary_calculate_id   = salaryCalculateId;
      this.form.grossSalary = grossSal;
      this.form.employee    = this.employee;
        this.$axios({
          method        : "POST",
          data          : this.form,
          url           : this.$SalaryEmail,
          responseType  : 'blob',
          headers       : this.getAuthHeader()
        }).then((response) => {

          this.$refs[refi][0].loading  = false;
          let anchor = this.$refs[salaryCalculateId+'-icon1'][0];
          $(anchor).addClass('d-block');
          $root.$toast.success('Salary slip has been sent on your email!');
        })
        .catch((error) => {
          console.log(error);
          this.is_data_ready = true;
        });
    },
    downloadFile(response) {
      const url   = window.URL.createObjectURL(new Blob([response]));
      const link  = document.createElement('a');
      link.href   = url;
      link.setAttribute('download', 'salarySlip.pdf');
      document.body.appendChild(link);
      link.click();
      // window.open(this.path, "_blank");
    },
    amountFormatter(value){
     return this.currencyFormatter(value);
    },
  },
};
</script>

<style scoped>
.download-icon {
  cursor: pointer;
}
.action-btn-cus{
  position: relative;
}
.action-btn-cus .v-spinner{
  position: absolute;
  left: 32%;
  top: 0px;
}
</style>
